import {createSelector} from 'reselect';

import type {NutshellState} from '../../../store';

const getTaskReportState = (state: NutshellState) => state.reports.tasks;

export const getSummaryState = createSelector([getTaskReportState], (taskReportState) => {
    return taskReportState.summary;
});

export const getSummaryIsLoading = createSelector([getSummaryState], (summaryState) => {
    return summaryState.isLoading;
});

export const getSummaryHasError = createSelector([getSummaryState], (summaryState) => {
    return summaryState.hasError;
});

export const getSummaryData = createSelector([getSummaryState], (summaryState) => {
    return summaryState.data;
});

export const getSummaryTotals = createSelector([getSummaryState], (summaryState) => {
    return summaryState.totals;
});
